var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default"},[(_vm.$route.meta.header)?_c('Header',{attrs:{"path":_vm.$route.path}}):_vm._e(),_c('div',{staticClass:"shop-body"},[_c('main',{staticClass:"main"},[_c('div',[_c('router-view')],1)])]),(_vm.$route.meta.footer)?_c('Footer',{attrs:{"path":_vm.$route.path}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }